module.exports = __webpack_public_path__ + "assets/img/special.e740eb20.png";